'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveModalName = undefined;

var _immutable = require('immutable');

var getActiveModalName = exports.getActiveModalName = function getActiveModalName(state) {
  return state.getIn(['modal', 'activeModalName'], '');
};
exports.default = {};
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/selectors.js
// module id = 508
// module chunks = 0